import React from 'react';
import { AnimatePresence } from 'framer-motion';

const NumberSelectionDialog = ({ isOpen, onClose, onSelect }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div
          onClick={onClose}
          className="absolute inset-0 rounded-lg overflow-hidden z-[300]"
        >
          {/* Semi-transparent backdrop with blur */}
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
          
          {/* Content */}
          <div
            onClick={e => e.stopPropagation()}
            className="absolute inset-0 flex flex-col z-[310]"
          >
            {/* Message */}
            <div className="absolute inset-0 mx-6 flex flex-col items-center justify-center mb-[100px] gap-2">
              <p className="text-[15px] text-white font-medium text-center font-['VT323']">
                How many similar images would you like?
              </p>
            </div>

            {/* Number selection buttons */}
            <div className="absolute bottom-0 w-full p-3 flex flex-col items-center gap-3 z-[320]">
              <div className="flex justify-center gap-2">
                <button
                  onClick={() => {
                    onSelect(1);
                    onClose();
                  }}
                  className="h-8 w-8 text-[14px] text-white bg-white/10 hover:bg-white/20 active:bg-white/30 transition-colors duration-200 rounded font-['VT323']"
                >
                  1
                </button>
                <button
                  onClick={() => {
                    onSelect(2);
                    onClose();
                  }}
                  className="h-8 w-8 text-[14px] text-white bg-white/10 hover:bg-white/20 active:bg-white/30 transition-colors duration-200 rounded font-['VT323']"
                >
                  2
                </button>
                <button
                  onClick={() => {
                    onSelect(3);
                    onClose();
                  }}
                  className="h-8 w-8 text-[14px] text-white bg-white/10 hover:bg-white/20 active:bg-white/30 transition-colors duration-200 rounded font-['VT323']"
                >
                  3
                </button>
                <button
                  onClick={() => {
                    onSelect(4);
                    onClose();
                  }}
                  className="h-8 w-8 text-[14px] text-white bg-white/10 hover:bg-white/20 active:bg-white/30 transition-colors duration-200 rounded font-['VT323']"
                >
                  4
                </button>
              </div>
              <button
                onClick={onClose}
                className="h-8 px-4 text-[14px] text-white/70 hover:text-white transition-colors duration-200 font-['VT323']"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default NumberSelectionDialog; 